import type { PatchSegmentOpenAPIRequestBody } from '../generated/operations/raw-openapi-request-body-for-serializers';
import type { SegmentSemanticInstruction } from '../schema-overrides';

type JSONPatch = PatchSegmentOpenAPIRequestBody;

interface SemanticPatch {
  comment?: string;
  environmentKey?: string;
  instructions: SegmentSemanticInstruction[];
}

export type PatchSegmentRequestBody = JSONPatch | SemanticPatch;

export function bodySerializer(body: PatchSegmentRequestBody): string {
  return JSON.stringify(body);
}
